export const COMPANY_INFO = {
  name: 'Docuit ink',
  cvr: '43481932',
  phone: '28 90 75 50',
  phoneRaw: '28907550',
  email: 'Lyager160788@gmail.com',
  address: 'Gl. Landevej 14',
  city: 'Vester Sottrup, 6400 Sønderborg',
  fullAddress: 'Gl. Landevej 14, Vester Sottrup, 6400 Sønderborg',
  facebook: 'https://www.facebook.com/people/Docuit-Art/100074491689197/',
  openingHours: 'Efter aftale',
  logo: 'https://assets.auxodev.dk/assets/b7bd9965-d19c-45c5-aaa1-9572b70fbe0d/ingen-tilgaengelig-billedbeskrivelse.png',
  heroImage: 'https://assets.auxodev.dk/assets/b7bd9965-d19c-45c5-aaa1-9572b70fbe0d/docuit-ink-hero-studio.png',
  artistImage: 'https://assets.auxodev.dk/assets/b7bd9965-d19c-45c5-aaa1-9572b70fbe0d/731787384-18416521291176366-4174539703916214192-n.jpeg'
}

export const TATTOO_STYLES = [
  {
    id: 'black-grey',
    slug: 'black-grey',
    title: 'Black & Grey Realism',
    tagline: 'Fotorealistiske motiver, bløde overgange og dybe kontraster',
    description: 'Black & Grey er min største passion. Med præcis skyggelægning og sans for detaljen skaber jeg levende portrætter, dyremotiver og kunstneriske sleeves.',
    image: 'https://assets.auxodev.dk/assets/b7bd9965-d19c-45c5-aaa1-9572b70fbe0d/731045061-18416521708176366-4010521301665740221-n.jpeg'
  },
  {
    id: 'fine-line',
    slug: 'fine-line',
    title: 'Fine Line & Minimalisme',
    tagline: 'Hårfine streger, botaniske detaljer og rene mønstre',
    description: 'Minimalistiske tatoveringer kræver den absolut højeste håndværksmæssige præcision. Jeg udfører ultratynde linjer og sarte botaniske eller geometriske motiver.',
    image: 'https://assets.auxodev.dk/assets/b7bd9965-d19c-45c5-aaa1-9572b70fbe0d/730943313-18416521627176366-6309152058225962634-n.jpeg'
  },
  {
    id: 'lettering',
    slug: 'skrift-geometri',
    title: 'Skrift & Geometri',
    tagline: 'Skræddersyet kalligrafi, geometriske former og personlige citater',
    description: 'Skrift og geometriske mønstre tilpasses altid kroppens naturlige linjer. Jeg tegner unik custom skriftkunst og præcise geometriske motiver fra bunden.',
    image: 'https://assets.auxodev.dk/assets/b7bd9965-d19c-45c5-aaa1-9572b70fbe0d/730358150-18416521618176366-9127401460896115250-n.jpeg'
  },
  {
    id: 'japanese',
    slug: 'japansk',
    title: 'Japansk & Neo-Traditional',
    tagline: 'Stærke konturer, mytologiske elementer og ikoniske former',
    description: 'Klassiske japanske motiver og neo-traditionelle tatoveringer med dynamisk flow og stærke visuelle elementer tilpasset dit ønske.',
    image: 'https://assets.auxodev.dk/assets/b7bd9965-d19c-45c5-aaa1-9572b70fbe0d/730093970-18416521609176366-143007413382675506-n.jpeg'
  },
  {
    id: 'cover-up',
    slug: 'cover-up',
    title: 'Cover-up & Viderebygning',
    tagline: 'Forvandling af ældre tatoveringer til nye kunstværker',
    description: 'Har du en ældre tatovering, der har brug for fornyelse eller komplet dækning? Jeg udtænker kreative løsninger, der dækker det gamle motiv effektivt.',
    image: 'https://assets.auxodev.dk/assets/b7bd9965-d19c-45c5-aaa1-9572b70fbe0d/1000049882.jpg'
  },
  {
    id: 'oldschool-realistisk',
    slug: 'oldschool-realistisk',
    title: 'Oldschool & realistisk',
    tagline: 'Klassisk tatoveringshåndværk, markante motiver og realistiske detaljer',
    description: 'Kombinationen af klassiske oldschool motiver og realistiske detaljer skaber tidløse og udtryksfulde tatoveringer med stærke kontraster og flot dybde.',
    image: 'https://assets.auxodev.dk/assets/b7bd9965-d19c-45c5-aaa1-9572b70fbe0d/730943313-18416521627176366-6309152058225962634-n.jpeg'
  }
]

export const GALLERY_ITEMS = [
  {
    id: 'g1',
    title: 'Black & Grey Realism Detalje',
    style: 'black-grey',
    styleName: 'Black & Grey Realism',
    src: 'https://assets.auxodev.dk/assets/b7bd9965-d19c-45c5-aaa1-9572b70fbe0d/731787384-18416521291176366-4174539703916214192-n.jpeg',
    alt: 'Tatovering udført af Docuit ink i Vester Sottrup nær Sønderborg',
    placement: 'Arm',
    description: 'Detaljeret tatovering udført hos Docuit ink.'
  },
  {
    id: 'g2',
    title: 'Tatoveringsarbejde Docuit Ink',
    style: 'black-grey',
    styleName: 'Black & Grey Realism',
    src: 'https://assets.auxodev.dk/assets/b7bd9965-d19c-45c5-aaa1-9572b70fbe0d/731045061-18416521708176366-4010521301665740221-n.jpeg',
    alt: 'Realistisk tatovering i sort og grå',
    placement: 'Underarm',
    description: 'Præcis skyggelægning og dybe kontraster.'
  },
  {
    id: 'g3',
    title: 'Oldschool & realistisk Motiv',
    style: 'oldschool-realistisk',
    styleName: 'Oldschool & realistisk',
    src: 'https://assets.auxodev.dk/assets/b7bd9965-d19c-45c5-aaa1-9572b70fbe0d/730943313-18416521627176366-6309152058225962634-n.jpeg',
    alt: 'Oldschool og realistisk tatovering af Docuit ink',
    placement: 'Skulder / Arm',
    description: 'Oldschool og realistiske detaljer med høj kontrast.'
  },
  {
    id: 'g4',
    title: 'Sort/grå Realisme & Motiv',
    style: 'black-grey',
    styleName: 'Black & Grey Realism',
    src: 'https://assets.auxodev.dk/assets/b7bd9965-d19c-45c5-aaa1-9572b70fbe0d/730358150-18416521618176366-9127401460896115250-n.jpeg',
    alt: 'Realistisk tatovering af Docuit ink',
    placement: 'Arm',
    description: 'Black & grey realism tatovering tilpasset kroppens anatomi.'
  },
  {
    id: 'g7',
    title: 'Kontrastrigt Motivarbejde',
    style: 'black-grey',
    styleName: 'Black & Grey Realism',
    src: 'https://assets.auxodev.dk/assets/b7bd9965-d19c-45c5-aaa1-9572b70fbe0d/729451746-18416521600176366-4047649676652208736-n.jpeg',
    alt: 'Sort og grå tatovering',
    placement: 'Lår / Legg',
    description: 'Velafbalanceret mørke og lys overgang.'
  },
  {
    id: 'g8',
    title: 'Oldschool & realistisk Kunstværk',
    style: 'oldschool-realistisk',
    styleName: 'Oldschool & realistisk',
    src: 'https://assets.auxodev.dk/assets/b7bd9965-d19c-45c5-aaa1-9572b70fbe0d/728093422-18416521669176366-7227965451428430787-n.jpeg',
    alt: 'Oldschool og realistisk tatovering',
    placement: 'Underarm',
    description: 'Harmonisk og tidløs kropskunst.'
  },
  {
    id: 'g9',
    title: 'Præcist Håndværk',
    style: 'black-grey',
    styleName: 'Black & Grey Realism',
    src: 'https://assets.auxodev.dk/assets/b7bd9965-d19c-45c5-aaa1-9572b70fbe0d/724221443-18414447376176366-5035409673525222132-n.jpeg',
    alt: 'Tatovering fra Docuit ink Vester Sottrup nær Sønderborg',
    placement: 'Overarm',
    description: 'Høj kvalitet med sans for de små nuancer.'
  },
  {
    id: 'g11',
    title: 'Moderne Black & Grey',
    style: 'black-grey',
    styleName: 'Black & Grey Realism',
    src: 'https://assets.auxodev.dk/assets/b7bd9965-d19c-45c5-aaa1-9572b70fbe0d/721757011-18414447355176366-6638322498219040491-n.jpeg',
    alt: 'Moderne sort-grå tatovering',
    placement: 'Legg',
    description: 'Flot skyggeeffekt og skarpe konturer.'
  },
  {
    id: 'g12',
    title: 'Sort/grå Realisme Projekt',
    style: 'black-grey',
    styleName: 'Black & Grey Realism',
    src: 'https://assets.auxodev.dk/assets/b7bd9965-d19c-45c5-aaa1-9572b70fbe0d/721119434-18414447298176366-1192063097274587282-n.jpeg',
    alt: 'Realistisk Black & Grey tatovering',
    placement: 'Bryst / Rygside',
    description: 'Unik designløsning efter kundens ønske.'
  },
  {
    id: 'g13',
    title: 'Oldschool & realistisk Detalje',
    style: 'oldschool-realistisk',
    styleName: 'Oldschool & realistisk',
    src: 'https://assets.auxodev.dk/assets/b7bd9965-d19c-45c5-aaa1-9572b70fbe0d/718014467-18412808353176366-3346139023676090985-n.jpeg',
    alt: 'Oldschool og realistisk tatovering fra Docuit ink',
    placement: 'Håndled / Arm',
    description: 'Sart og udtryksfuldt udtryk.'
  }
]

export const PROCESS_STEPS = [
  {
    step: '01',
    title: 'Idé og Bookingforespørgsel',
    description: 'Du sender mig din idé, dine ønsker til størrelse og placering samt eventuelle referencebilleder via formularen eller direkte pr. telefon.'
  },
  {
    step: '02',
    title: 'Dialog og Rådgivning',
    description: 'Jeg gennemgår din forespørgsel, vurderer stilen og rådgiver dig om den bedste løsning i forhold til kroppens konturer og hudtype.'
  },
  {
    step: '03',
    title: 'Design og Forberedelse',
    description: 'Motivet skræddersyes til dig. På dagen tilpasses stencilen nøjagtigt til din krop, så du kan se og godkende placeringen før jeg starter.'
  },
  {
    step: '04',
    title: 'Tatovering og Efterbehandling',
    description: 'Selve sessionen udføres under sterile, trygge forhold. Bagefter får du grundig instruktion og rådgivning i korrekt efterbehandling.'
  }
]
